import { Link } from "react-router-dom";

import { useMobileNav } from "../../store/context/MobileNavContext.js";
import { SITE_NAME } from "../../services/lib/constants.js";
import logoFull from "../../assets/logo.png";
function LogoFull() {
  const { closeMenu } = useMobileNav();

  return (
    <Link to="/" onClick={closeMenu}>
      <img
        src={logoFull}
       width="35"
        height="50"
        alt={SITE_NAME}
        title={`${SITE_NAME} logo`}
      />
    </Link>
  );
}

export default LogoFull;
